import { io } from 'socket.io-client';

let socket = null;
let connected = false;

// connect to socket.io server
const socketConnect = (url) => {
    return new Promise((resolve, reject) => {
        if (socket) {
            // console.log("Socket connection already there.");
            return resolve(socket);
        }

        socket = io(url, {
            path: '/io',
            // transports: ["polling", "websocket", "webtransport"], // Default value
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 2000,
            timeout: 5000
        });

        // Successful connection
        socket.on('connect', () => {
            connected = true;
            // console.log("Socket connected: ", socket.id);
            resolve(socket);
        });

        // Connection error
        socket.on('connect_error', (err) => {
            // console.error("Socket connetion error ", err);
            reject(err);
        });

        // Fired upon every reconnecting attempt
        socket.on('reconnecting', (attempt) => {
            // console.log("Reconnecting attamp ", attempt);

        });

        // Fired upon a successful reconnection.
        socket.on('reconnect', (attempt) => {
            // console.log(`Socket reconnected upon ${attempt} attempt.`);
        });

        // Fired upon a reconnection attempt error.
        // socket.io.on("reconnect_error", (error) => {
        //     console.error("Reconnecton attamp ", error);
        // });

        // Fired when couldn't reconnect within reconnection attempts
        socket.on('reconnect_failed', () => {
            console.error("Reconnection failed");
        });

        // This event is fired upon disconnection.
        socket.on('disconnect', (reason) => {
            connected = false;
            // console.log("Disconnected: ", reason);
        });

        // Listen all event
        socket.onAny((eventName, ...args) => {
            // console.log(`Received event: ${eventName}`, args);
        });
    })
}

// Send event
const socketEventEmit = (event, data = {}) => {
    if (!socket) return console.error("Socket not initialized");
    socket.emit(event, data);
}

// Listen for event
const socketEventOn = (event, handler) => {
    if (!socket) return console.error("Socket not initialized");
    socket.on(event, handler);
}

// Remove event listener
const socketEventOff = (event, handler) => {
    if (!socket) return console.error("Socket not initialized");
    socket.off(event, handler);
}

// Disconnect
const socketDisconnect = () => {
    if (!socket) return;
    socket.disconnect();
    socket = null;
    connected = false;
}


export { socket, connected, socketConnect, socketEventEmit, socketEventOn, socketEventOff, socketDisconnect };
